import {Phase2Api} from "../api";
import {getSNodeID} from "../../../../../components/scheduling/util";

export function getSelectedEntities(api: Phase2Api){
    return api.data.originalEntities.get()
        .filter((entity) => api.scheduledToExpectedPaxCgo.selectedEntityIds.includes(getSNodeID(api.toScheduleNode(entity))))
}